import { Box, type SxProps } from '@mui/material';
import Image from 'next/image';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType } from '@repo/segment/enums';
import type { AnalyticsType } from '@repo/segment/types';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph/marketplace/enums';
import type { CtaType, ImageType } from '@repo/supergraph/marketplace/types';

type Props = {
  ctaAnalytics: AnalyticsType;
  cta?: CtaType;
  image?: ImageType;
  displayName: string;
  width: number;
  height: number;
  sx?: SxProps;
};

// Fixed-size box with the logo fit (not cropped) and centered inside it.
export function RateTableLogo({ ctaAnalytics, cta, image, displayName, width, height, sx }: Props) {
  if (!image?.source) return null;

  const logo = (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width,
        height,
        marginX: 'auto',
      }}
    >
      <Image
        src={image.source}
        alt={image.alt ?? displayName}
        fill
        sizes={`${width}px`}
        style={{ objectFit: 'contain' }}
      />
    </Box>
  );

  return (
    <Box sx={[{ display: 'flex', justifyContent: 'center', width: '100%' }, ...[sx ?? {}].flat()]}>
      {cta ? (
        <CtaLink
          cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductImage }}
          analyticsPayload={ctaAnalytics}
          linkType={LinkType.PRODUCT_IMAGE}
          monetizable={ctaAnalytics.monetizable}
          sx={{ display: 'block' }}
        >
          {logo}
        </CtaLink>
      ) : (
        logo
      )}
    </Box>
  );
}
